import { Box, Divider, styled, useTheme } from '@mui/material';
import ExistingNotesSection from './ExistingNotesSection';
import AddNoteSection from './AddNoteSection';
import { useQueryInternalRoleNotes } from './queries';
import { getAxiosErrorMessageByStatusCode } from 'hooks/errorHandling/errorHandlingHooks';
import { Alert } from 'sharedComponents/Alert';
import { ATSTabbedJobViewInternalRoleNotesTestIds } from 'data-testids/ATS';

const InternalNotesTab: React.FC<{ jobId: number }> = ({ jobId }) => {
  const theme = useTheme();

  const { error } = useQueryInternalRoleNotes<number>(jobId);
  const errorMessage = getAxiosErrorMessageByStatusCode(error);

  if (errorMessage) {
    return (
      <Alert dataTestId={ATSTabbedJobViewInternalRoleNotesTestIds.ERROR_MESSAGE} type="error">
        {errorMessage ?? 'Something went wrong'}
      </Alert>
    );
  }

  return (
    <TabContainer>
      <ExistingNotesSection jobId={jobId} />
      <Divider sx={{ borderColor: theme.palette.border.main, pt: 4 }} />
      <AddNoteSection jobId={jobId} />
    </TabContainer>
  );
};

export default InternalNotesTab;

const TabContainer = styled(Box)(({ theme }) => ({
  maxWidth: theme.breakpoints.values.md,
}));
